export const TEST_ID = 'badge';
